import { User } from "lucide-react";

interface ProfileAvatarProps {
  profilePicture?: string;
  fullName?: string;
  username?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function ProfileAvatar({ 
  profilePicture, 
  fullName, 
  username, 
  size = "md",
  className = ""
}: ProfileAvatarProps) {
  const sizeClasses = {
    sm: "w-8 h-8 text-sm",
    md: "w-10 h-10 text-base",
    lg: "w-16 h-16 text-lg"
  };

  const initials = fullName?.charAt(0) || username?.charAt(0) || 'U';

  return (
    <div className={`${sizeClasses[size]} rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white font-semibold overflow-hidden ${className}`}>
      {profilePicture ? (
        <img
          src={profilePicture}
          alt="Profile"
          className="w-full h-full object-cover"
        />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
}